module.exports = __webpack_public_path__ + "img/poster3.eecae16a.jpg";